import {FC, useEffect, useState} from 'react'
import {Col, Row} from 'react-bootstrap'
import DateRangePickers from '../../../sharedComponent/DateRangePickers/DateRangePickers'
import {useLazyQuery} from '@apollo/client'
import {
  GET_AGENTS_BY_SALES_CHANNEL_IDS,
  GET_AGENT_LEADER_LIST_FOR_AGENT,
  GET_SALES_CHANNEL_ADMIN_DASHBOARD,
  GET_TOTAL_TPV_LIST,
} from '../../../../utils/GraphQLAPI'
import DropdownFilter from '../../../sharedComponent/DropdownFilter/DropdownFilter'
import moment from 'moment'
import ConversionRateCard from '../../../sharedComponent/RadialChart/ConversionRateCard'
import EnrollmentCreatedCard from './EnrollmentCreatedCard'
import {DashboardList} from './DashboardList'
import DonutPieChart from '../../../sharedComponent/DonutPieChart/DonutPieChart'
import Breadcrumbs from '../../../sharedComponent/Breadcrumbs/Breadcrumbs'
import { GLOBAL_CONSTANTS, fetchPolicyKey } from '../../../../utils/GlobalConstants'

const DashboardPage: FC = () => {
  const [customerEnrollment, setCustomerEnrollment] = useState<any>()
  const [tpvStatus, setTpvStatus] = useState<any>()
  const [conversionRate, setConversionRate] = useState<any>()
  const [total, setTotal] = useState<number>()
  const [tpvs, setTpvs] = useState<any>([])
  const [page, updatePage] = useState(0)
  const [fromDate, setFromDate] = useState<any>()
  const [toDate, setToDate] = useState<any>()
  const [agentOptions, setAgentOptions] = useState<any>([])
  const [agentLeaderOptions, setAgentLeaderOptions] = useState<any>([])
  const dateFormat = 'YYYY-MM-DD'
  const [listOptions, setListOptions] = useState<any>({
    agentIds: null,
    fromDate: new Date(
      moment(moment().subtract(29, 'days').toDate()).format(dateFormat) + 'T00:00:00'
    ).toISOString(),
    toDate: new Date(moment(moment().toDate()).format(dateFormat) + 'T23:59:00').toISOString(),
    page: 1,
    perPage: 10,
  })

  const [filterOptions, setFilterOptions] = useState<any>({
    agentIds: null,
    agentLeaderIds: null,
    fromDate: new Date(
      moment(moment().subtract(29, 'days').toDate()).format(dateFormat) + 'T00:00:00'
    ).toISOString(),
    toDate: new Date(moment(moment().toDate()).format(dateFormat) + 'T23:59:00').toISOString(),
  })

  // Date Set
  useEffect(() => {
    setFromDate(
      new Date(
        moment(moment().subtract(29, 'days').toDate()).format(dateFormat) + 'T00:00:00'
      ).toISOString()
    )
    setToDate(new Date(moment(moment().toDate()).format(dateFormat) + 'T23:59:00').toISOString())
  }, [])

  // Dashboard Chart Data Fetch
  const [getSalesAdminDashboardData, {loading: reload}] = useLazyQuery(
    GET_SALES_CHANNEL_ADMIN_DASHBOARD,
    {
      fetchPolicy: fetchPolicyKey,
      onCompleted: (data1) => {
        setCustomerEnrollment(data1?.getSalesChannelAdminDashboard.customerEnrollment)
        setTpvStatus(data1?.getSalesChannelAdminDashboard.tpvReports)
        setConversionRate(data1?.getSalesChannelAdminDashboard.conversionRate)
      },
    }
  )

  // Total TPV List Fetch
  const [getTotalTpvList, { loading }] = useLazyQuery(GET_TOTAL_TPV_LIST, {
    fetchPolicy: fetchPolicyKey,
    onCompleted: (data) => {
      setTpvs(data.getTotalTpvList.totalTpvList)
      setTotal(data.getTotalTpvList.totalTpvs)
    },
    onError: (err) => console.log('error', err),
  })

  //get agents by agent leader Id's
  const [getAgentsByAgentLeaderId] = useLazyQuery(GET_AGENTS_BY_SALES_CHANNEL_IDS, {
    onCompleted: (data) => {
      setAgentOptions(
        data.getAgentsBySalesChannelIds.agents.map(
          ({agentFirstName, agentLastName, agentId}: any) => ({
            firstName: agentFirstName,
            lastName: agentLastName,
            id: agentId,
          })
        )
      )
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })

  // Filter - Date Range
  const getdataFromDateFilter = (fromDateObj: any, toDateObj: any, objDays: any) => {
    // console.log('objDays', objDays)
    const agentFilter = localStorage.getItem('agentFilter')
      ? localStorage.getItem('agentFilter')
      : null
    setFromDate(fromDateObj)
    setToDate(toDateObj)
    setFilterOptions((prevOptions: any) => {
      return {
        ...prevOptions,
        agentIds: agentFilter ? JSON.parse(agentFilter) : null,
        fromDate: fromDateObj,
        toDate: toDateObj,
      }
    })
    setListOptions((prevOptions: any) => {
      return {
        ...prevOptions,
        agentIds: agentFilter ? JSON.parse(agentFilter) : null,
        fromDate: fromDateObj,
        toDate: toDateObj,
      }
    })
  }
  // Agent Filter
  const applyAgentFilter = (agentFilterIds: any) => {
    localStorage.removeItem('agentFilter')
    localStorage.setItem('agentFilter', JSON.stringify(agentFilterIds))
    setFilterOptions((prevOptions: any) => {
      return {...prevOptions, agentIds: agentFilterIds, fromDate, toDate}
    })
    setListOptions((prevOptions: any) => ({
      ...prevOptions,
      agentIds: agentFilterIds,
      fromDate,
      toDate,
    }))
  }
  // Agent Filter
  const applyAgentLeaderFilter = (agentLeaderFilterIds: any) => {
    if (agentLeaderFilterIds.length) {
      getAgentsByAgentLeaderId({
        variables: {
          agentLeadIds: agentLeaderFilterIds,
          agentListInput: null,
          salesChannelIds: null,
        },
      })
      setFilterOptions((prevOptions: any) => {
        return {...prevOptions, agentLeaderIds: agentLeaderFilterIds, fromDate, toDate}
      })
      setListOptions((prevOptions: any) => ({
        ...prevOptions,
        agentLeaderIds: agentLeaderFilterIds,
        fromDate,
        toDate,
      }))
    } else {
      getAgentListForFilter({})
    }
  }

  //agent leader filter
  const updateRowsPerPage = (value: any) => {
    setListOptions((prevOptions: any) => ({...prevOptions, perPage: value, page: page + 1}))
  }

  useEffect(() => {
    setListOptions((prevOptions: any) => ({...prevOptions, page: page + 1}))
  }, [page])

  // Dashboard API Hit
  useEffect(() => {
    getSalesAdminDashboardData({
      variables: {
        salesChannelAdminDashboardInput: filterOptions,
      },
    })
  }, [filterOptions])

  // Dashboard List API Hit
  useEffect(() => {
    getTotalTpvList({
      variables: {
        totalTpvListInput: listOptions,
      },
    })
  }, [listOptions])
  //agentList
  // Filter Query
  const [getAgentListForFilter] = useLazyQuery(GET_AGENTS_BY_SALES_CHANNEL_IDS, {
    fetchPolicy: fetchPolicyKey,
    onCompleted: (data) => {
      setAgentOptions(
        data.getAgentsBySalesChannelIds.agents.map((x: any) => ({
          checked: false,
          firstName: x.agentFirstName,
          lastName: x.agentLastName,
          id: x.agentId,
          ...x,
        }))
      )
    },
  })
  // agent Leader API
  const [getAgentLeaderList] = useLazyQuery(GET_AGENT_LEADER_LIST_FOR_AGENT, {
    onCompleted: (data) =>
      setAgentLeaderOptions(
        data.getAgentLeaderListForAgent.map((agentLeader: any) => ({
          ...agentLeader,
          firstName: agentLeader.leaderName,
          checked: false,
        }))
      ),
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  useEffect(() => {
    getAgentListForFilter({})
    getAgentLeaderList({
      variables: {
        salesChannelId: '',
      },
    })
  }, [])

  return (
    <>
      <div className='d-flex justify-content-between align-items-center'>
        <Breadcrumbs title='Dashboard' subTitle='Home - Dashboard' />

        <div className='d-flex w-40 justify-content-evenly align-items-center'>
          <div className='mx-2'>
            <DropdownFilter
              title={'Agent Leaders'}
              colors={'white'}
              options={agentLeaderOptions}
              setOptions={setAgentLeaderOptions}
              applyFilter={applyAgentLeaderFilter}
            />
          </div>
          <div className='mx-2'>
            <DropdownFilter
              title={'Agents'}
              colors={'white'}
              options={agentOptions}
              setOptions={setAgentOptions}
              applyFilter={applyAgentFilter}
            />
          </div>
          <div className='mx-2'>
            <DateRangePickers getdataFromDateFilter={getdataFromDateFilter} colors={'white'} />
          </div>
        </div>
      </div>
      {/* Dashboard Cards Start */}
      <Row>
        <Col md lg xl='5' mb-md-5 mb-xl-10>
          {/* Utility Card */}
          <DonutPieChart data={tpvStatus} heading='TPV Status' subheading='TPVs' reload={reload} />
        </Col>
        <Col md lg xl='4' mb-md-5 mb-xl-10>
          {/* Conservation Rate */}
          <ConversionRateCard
            data={conversionRate}
            heading='Conversion Rate'
            subheading='TPVs'
            reload={reload}
            top='87%'
            classname={'sales'}
          />
        </Col>
        <Col md lg xl='3' mb-md-5 mb-xl-10>
          {/* EnrollmentCreated Card */}
          <EnrollmentCreatedCard data={customerEnrollment} />
        </Col>
      </Row>
      {/* List */}
      <DashboardList
        total={total}
        loading={loading}
        tpvs={tpvs}
        page={page}
        updatePage={updatePage}
        listOptions={listOptions}
        updateRowsPerPage={updateRowsPerPage}
      />
    </>
  )
}

const SalesAdminDashboard: FC = () => <DashboardPage />

export {SalesAdminDashboard}
